import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ItemEmptySinistre from 'containers/AutoDetailsPage/SuivreSinistreTab/EmptyItemSinistre';
import { translate } from 'helpers/intl';
import messages from 'containers/AutoDetailsPage/messages';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import {
  StyledtBlocWrapper,
  SizedSmallSectionHeader,
} from 'containers/AutoDetailsPage/SuivreSinistreTab/styles';
import {
  getAllSinistre,
  getSinistreDetailsSelector,
  getIsLoadingSelector,
} from 'store/sinistre/selectors';
import SuivreSinitre from 'containers/AutoDetailsPage/SuivreSinistreTab/Sinistres';
import { getSinistreDetails } from 'store/sinistre/actions';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const SuivreSinitreTab = (props: {
  intl: IntlShape;
  allSinistre?: any;
  getSinistreDetails: Function;
  sinistreDetails: {
    title: string;
    subtitle: string;
    actualDate: any;
    timelineState: string;
    shareName: string;
    status: string;
    description: string;
  }[];
  isLoading: boolean;
}) => {
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.AUTO_DETAILS}
      label="Suivi de mes sinistres_Tab 1_Suivi de mes sinistres"
    >
      <StyledtBlocWrapper height="auto">
        <Grid item>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate({ ...messages.sinitre_title }, props)}
          </SizedSmallSectionHeader>
        </Grid>
        {props.allSinistre ? (
          <SuivreSinitre
            sinistres={props.allSinistre}
            getSinistreDetails={props.getSinistreDetails}
            sinistreDetails={props.sinistreDetails}
            isLoading={props.isLoading}
          />
        ) : (
          <ItemEmptySinistre />
        )}
      </StyledtBlocWrapper>
    </GaLoadHOC>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    allSinistre: any;
    sinistreDetails: {
      title: string;
      subtitle: string;
      actualDate: any;
      timelineState: string;
      shareName: string;
      status: string;
      description: string;
    }[];
    isLoading: boolean;
  }
>({
  allSinistre: getAllSinistre,
  sinistreDetails: getSinistreDetailsSelector,
  isLoading: getIsLoadingSelector,
});

const mapDispatchToProps = {
  getSinistreDetails,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(SuivreSinitreTab));
